import React from 'react';
import classNames from 'classnames';

import { renderList } from '../../../helpers';
import { Skeleton } from '../../Skeleton';

import './CouponCardSkeleton.scss';

const CouponCardSkeleton = ({
  width,
  height,
  variant,
  animation,
  isLoading,
  numberOfElements,
  children,
}) => {
  const renderCardContentSkeleton = (variant) =>
    ({
      reward: (
        <>
          <div>
            <Skeleton
              isLoading={isLoading}
              animation={animation}
              variant="rounded"
              width="90%"
              height="0.54em"
            />
          </div>
          <div>
            <Skeleton
              isLoading={isLoading}
              animation={animation}
              variant="rounded"
              width="70%"
              height="0.54em"
            />
          </div>
          <div className="flex align-center justify-between">
            <Skeleton isLoading={isLoading} animation={animation} variant="rounded" width="40%" />
            <Skeleton
              isLoading={isLoading}
              animation={animation}
              variant="circular"
              width="1.71em"
              height="1.71em"
            />
          </div>
        </>
      ),
      swipe: (
        <>
          <div className="flex align-center justify-between">
            <Skeleton
              isLoading={isLoading}
              animation={animation}
              variant="rounded"
              width="20%"
              height="1.14em"
            />
            <Skeleton
              isLoading={isLoading}
              animation={animation}
              variant="rounded"
              width="60%"
              height="0.54em"
            />
          </div>
          <div className="flex align-center justify-between">
            <Skeleton
              isLoading={isLoading}
              animation={animation}
              variant="rounded"
              width="100%"
              height="2.85em"
              borderRadius="2.282em"
            />
          </div>
        </>
      ),
      coupon: (
        <>
          <div className="coupon_content">
            <div>
              <Skeleton
                isLoading={isLoading}
                animation={animation}
                variant="rounded"
                width="100%"
                height="0.54em"
              />
            </div>
            <div>
              <Skeleton
                isLoading={isLoading}
                animation={animation}
                variant="rounded"
                width="70%"
                height="0.54em"
              />
            </div>
            <div>
              <Skeleton
                isLoading={isLoading}
                animation={animation}
                variant="rounded"
                width="80%"
                height="0.54em"
              />
            </div>
            <div>
              <Skeleton
                isLoading={isLoading}
                animation={animation}
                variant="rounded"
                width="40%"
                height="0.54em"
              />
            </div>
          </div>
          <div>
            <Skeleton
              isLoading={isLoading}
              animation={animation}
              variant="rounded"
              width="100%"
              height="2.85em"
            />
          </div>
        </>
      ),
    }[variant]);

  return isLoading ? (
    <div className={classNames('flex justify-between card-list mt-16', variant)}>
      {renderList(numberOfElements).map(() => (
        <div
          className={classNames('flex flex-column card custom-size', variant)}
          style={{ '--height': height, '--width': width }}
        >
          <div className="flex-1">
            <Skeleton
              isLoading={isLoading}
              animation={animation}
              variant="rounded"
              width="100%"
              height="100%"
            />
          </div>
          {renderCardContentSkeleton(variant)}
        </div>
      ))}
    </div>
  ) : (
    children
  );
};

CouponCardSkeleton.defaultProps = {
  animation: 'pulse',
  variant: 'reward',
  numberOfElements: 6,
};

export default CouponCardSkeleton;
